"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CardDescription = void 0;
const vue_1 = require("vue");
const ICardRenderDescription_1 = require("../../cards/render/ICardRenderDescription");
const utils_1 = require("../../utils/utils");
exports.CardDescription = vue_1.default.component('CardDescription', {
    props: {
        item: {
            required: true,
        },
    },
    methods: {
        getClasses: function () {
            const classes = ['card-description'];
            if (ICardRenderDescription_1.isIDescription(this.item)) {
                if (this.item.align !== 'center') {
                    classes.push('card-description-aligned');
                }
                classes.push('card-description-align--' + this.item.align);
            }
            return utils_1.generateClassString(classes);
        },
        getDescription: function () {
            return ICardRenderDescription_1.isIDescription(this.item) ? this.item.text : this.item;
        },
    },
    template: `
      <div :class="getClasses()">({{ getDescription() }})</div>
  `,
});
//# sourceMappingURL=CardDescription.js.map